class NewsLetterModalWidget {
	constructor() {
		this.modalEl = document.querySelector('.nx-newsletter-modal');
		if (!this.modalEl) {
			return;
		}

		this.modalBtn = this.modalEl.querySelector('.nx-newsletter-modal__btn');
		if (!this.modalBtn) {
			return;
		}

		this.modalMobileCloseBtn = this.modalEl.querySelector(
			'.nx-newsletter-modal__mobile-close-btn'
		);
		if (!this.modalMobileCloseBtn) {
			return;
		}

		// Toggle Modal
		this.modalBtn.addEventListener('click', () => this.modalOpenToggle());
		this.modalMobileCloseBtn.addEventListener('click', () =>
			this.modalOpenToggle()
		);

		// Set Class to Filled Inputs
		let intervalCounter = 0;
		const interval = setInterval(() => {
			if (intervalCounter > 9) {
				clearInterval(interval);
			}

			intervalCounter++;

			this.hsFormTextInputs = this.modalEl.querySelectorAll(
				'.hs-input[type=text]:not(.hs-input[name=country]):not(.hs-input[name=state]), .hs-input[type=email]'
			);
			if (this.hsFormTextInputs.length === 0) {
				return;
			}

			this.hsFormTextInputs.forEach((hsFormTextInput) => {
				hsFormTextInput.addEventListener('change', (event) => {
					const target = event.target;

					// If Input is empty
					if (target.value.length > 0) {
						event.target.parentElement.parentElement.classList.add(
							'hs-input_filled'
						);
					} else {
						event.target.parentElement.parentElement.classList.remove(
							'hs-input_filled'
						);
					}
				});
			});

			clearInterval(interval);
		}, 100);
	}

	modalOpenToggle() {
		const modalActiveClass = 'nx-newsletter-modal_active';
		this.modalEl.classList.toggle(modalActiveClass);
	}
}

export default NewsLetterModalWidget;
